import { SocialChannel } from '../SocialChannel'
import { replaceUrlPattern } from '../../../Generic/models/UrlPattern/replaceUrlPattern'

export function getFollowUrl(channel: SocialChannel) {
  return replaceUrlPattern(channel.type.followUrlPattern, { slug: channel.slug })
}
